import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { Subject } from 'rxjs';
import { YEAR_FORMATS } from 'app/constants/filter.constants';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-all-data-year-filter',
  templateUrl: './year-filter.component.html',
  styleUrls: ['./year-filter.component.scss'],
  providers: [provideMomentDateAdapter(YEAR_FORMATS)],
  imports: [
    MatFormField,
    MatInput,
    MatDatepickerInput,
    FormsModule,
    MatLabel,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
  ],
})
export class AllDataYearFilterComponent implements OnInit {
  @Input() set data(value: { dateFrom?: string; dateTo?: string } | undefined) {
    if (!value) {
      this.dateFrom = undefined;
      this.dateTo = undefined;

      return;
    }

    const { dateFrom, dateTo } = value;

    this.dateFrom = dateFrom ? new Date(dateFrom) : undefined;
    this.dateTo = dateTo ? new Date(dateTo) : undefined;
  }

  @Input() onClear!: Subject<void>;

  @Output() yearFilterChange = new EventEmitter<{
    dateFrom?: Date;
    dateTo?: Date;
  }>();

  dateFrom?: Date;
  dateTo?: Date;

  today = new Date();
  minDate = new Date(1900, 0);

  ngOnInit(): void {
    this.onClear.subscribe(() => {
      this.dateFrom = undefined;
      this.dateTo = undefined;
    });
  }

  onYearSelected(date: Date, datepicker: MatDatepicker<Date>, field: 'dateFrom' | 'dateTo') {
    if (field === 'dateFrom') {
      this.dateFrom = date;
    } else {
      this.dateTo = date;
    }

    this.yearFilterChange.emit({
      dateFrom: this.dateFrom,
      dateTo: this.dateTo,
    });

    datepicker.close();
  }
}
